export default __webpack_public_path__ + "static/media/logo-xd.b09b6daa.svg";